// Shared bits for the Loans screens: paise→₹ formatting, status chips and
// the error/empty lines every screen reuses.
import { formatIndianCurrency } from '@/utils/currency';
import type { LoanState } from '@/types/loan.types';

export const inr = (paise: number): string => formatIndianCurrency(paise / 100);

const STATE_LABELS: Partial<Record<LoanState, string>> = {
  underReview: 'Under review',
  approved: 'Approved',
  rejected: 'Not approved',
  cancelled: 'Cancelled',
  coolingOff: 'Cooling-off',
  active: 'Active',
  moratorium: 'Moratorium',
  unutilised: 'Limit not used',
  overdue: 'EMI overdue',
  closed: 'Closed',
  foreclosed: 'Foreclosed',
  defaulted: 'Defaulted',
};

const STATE_TONES: Partial<Record<LoanState, 'ok' | 'warn' | 'bad' | 'muted' | 'info'>> = {
  underReview: 'info',
  approved: 'ok',
  rejected: 'bad',
  cancelled: 'muted',
  coolingOff: 'info',
  active: 'ok',
  moratorium: 'info',
  unutilised: 'muted',
  overdue: 'bad',
  closed: 'muted',
  foreclosed: 'muted',
  defaulted: 'bad',
};

export const LoanStatusChip = ({ state }: { state: LoanState }) => (
  <span className={`nova-loan-chip nova-loan-chip-${STATE_TONES[state] ?? 'muted'}`}>
    {STATE_LABELS[state] ?? state}
  </span>
);

export const ErrorLine = ({ message }: { message: string }) =>
  message ? <p className="nova-loan-error" role="alert">{message}</p> : null;

export const EmptyLine = ({ children }: { children: string }) => (
  <p className="nova-loan-empty">{children}</p>
);
